import type { ICardTransaction } from "@/modules/card/common/types";
import { CURRENCY } from "@/shared/common/constants";
import { TransactionDirection, UiType } from "@/shared/common/enums";
import { formatDate } from "@/shared/helpers";
import type { ICellProps } from "@ab.uitools/ui-library/components/AdvancedTable/types";
import { Text } from "@ab.uitools/ui-library/components/Text";

interface Props {
  t: (s: string) => string;
}

export const getColumns = ({ t }: Props) => ([
  {
    id: "creation_date",
    header: t("cards.historyTable.date"),
    accessorKey: "creationDate",
    cell: ({ row }: ICellProps<ICardTransaction>) => {
      const date = formatDate(row.original?.creationDate);
      return (
        <Text>{date}</Text>
      );
    }
  },
  {
    id: "description",
    header: t("cards.historyTable.Purpose"),
    accessorKey: "description",
  },
  {
    id: "equivalent_in_AMD",
    header: t("cards.historyTable.calculatedAmount"),
    accessorKey: "convertedAmount",
    cell: ({ row }: ICellProps<ICardTransaction>) => {
      const amount = row.original?.convertedAmount;
      const currency = row.original?.convertedCurrency;
      const type = row.original?.transactionDirection === TransactionDirection.In ?
        UiType.Success : UiType.Danger;
      const symbol = type === UiType.Success ? "+" : "-";
      return (
        <Text type={type}>{`${symbol}${amount} ${CURRENCY[currency]?.symbol || currency}`}</Text>
      );
    },
  },
  {
    id: "transaction_amount",
    header: t("cards.historyTable.transactionAmount"),
    accessorKey: "convertedAmount",
    cell: ({ row }: ICellProps<ICardTransaction>) => {
      const amount = row.original?.amount;
      const type = row.original?.transactionDirection === TransactionDirection.In ?
        UiType.Success : UiType.Danger;
      const currency = row.original?.currency;
      const symbol = type === UiType.Success ? "+" : "-";
      return !!amount && (
        <Text type={type}>{`${symbol}${amount} ${CURRENCY[currency]?.symbol}`}</Text>
      );
    },
  }
]);
